import React, { useState } from "react";
import Header from "../components/Header";

const Blockwork = () => {
  const [selectedOption, setSelectedOption] = useState('centreLine');
  const [totalGirth, setTotalGirth] = useState('');
  const [breadth, setBreadth] = useState('');
  const [blockHeight, setBlockHeight] = useState('');
  const [results, setResults] = useState({});
  const [showResult, setShowResult] = useState(false);

  const [input1Groups, setInput1Groups] = useState([{ ddt1Length: '', ddt1Height: '', ddt1Quantity: '' }]);
  const [input2Groups, setInput2Groups] = useState([{ ddt2Length: '', ddt2Height: '', ddt2Quantity: '' }]);

  const handleAdd1Group = () => {
    setInput1Groups([...input1Groups, { ddt1Length: "", ddt1Height: "", ddt1Quantity: "" }]);
  };

  const handleAdd2Group = () => {
    setInput2Groups([...input2Groups, { ddt2Length: "", ddt2Height: "", ddt2Quantity: "" }]);
  };

  const handleDelete1Group = (index) => {
    const updated = input1Groups.filter((_, i) => i !== index);
    setInput1Groups(updated);
  };

  const handleDelete2Group = (index) => {
    const updated = input2Groups.filter((_, i) => i !== index);
    setInput2Groups(updated);
  };

  const handleInput1Change = (index, name, value) => {
    const updated = [...input1Groups];
    updated[index][name] = value;
    setInput1Groups(updated);
  };

  const handleInput2Change = (index, name, value) => {
    const updated = [...input2Groups];
    updated[index][name] = value;
    setInput2Groups(updated);
  };

  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
    setResults({});
    setInput1Groups([{ ddt1Length: '', ddt1Height: '', ddt1Quantity: '' }]);
    setInput2Groups([{ ddt2Length: '', ddt2Height: '', ddt2Quantity: '' }]);
    setShowResult(false);
  };

  const ClineGirtHandle = () => {
     if (!totalGirth || !blockHeight){
      alert(" Please fill all the fields");
      return;
    }
    const totalArea = totalGirth * blockHeight;

    const usedArea1 = input1Groups.reduce((sum, group) =>
      sum + (parseFloat(group.ddt1Length) || 0) * (parseFloat(group.ddt1Height) || 0) * (parseFloat(group.ddt1Quantity) || 0), 0);

    const usedArea2 = input2Groups.reduce((sum, group) =>
      sum + (parseFloat(group.ddt2Length) || 0) * (parseFloat(group.ddt2Height) || 0) * (parseFloat(group.ddt2Quantity) || 0), 0);

    const remainingArea = totalArea - (usedArea1 + usedArea2);
    const blockCalculate = Math.max(remainingArea * 10, 0);
    const percentage = 0.1 * blockCalculate;
    const final = percentage + blockCalculate;
    const cementNeeded = Math.ceil(final / 50);

    setResults({
      usedArea1: usedArea1.toFixed(2),
      usedArea2: usedArea2.toFixed(2),
      remainingArea: remainingArea.toFixed(2),
      totalBlocks: final.toFixed(2),
      cementBags: cementNeeded,
    });

    setShowResult(true);
  };

  const SquareMetreHandle = () => {
     if (!totalGirth || !breadth ||  !blockHeight){
      alert(" Please fill all the fields");
      return;
    }
    const Length = parseFloat(totalGirth);
    const B = parseFloat(breadth);
    const width = parseFloat(blockHeight);
    const perimeter = 2*( Length+ B );
    const totalArea = perimeter * width;
    const usedArea1 = input1Groups.reduce((sum, group) =>
      sum + (parseFloat(group.ddt1Length) || 0) * (parseFloat(group.ddt1Height) || 0) * (parseFloat(group.ddt1Quantity) || 0), 0);

    const usedArea2 = input2Groups.reduce((sum, group) =>
      sum + (parseFloat(group.ddt2Length) || 0) * (parseFloat(group.ddt2Height) || 0) * (parseFloat(group.ddt2Quantity) || 0), 0);
const remainingArea = totalArea - usedArea1 - usedArea2;
 const blockCalculate = Math.max(remainingArea * 10, 0);
    const percentage = 0.1 * blockCalculate;
    const final = percentage + blockCalculate;
    const cementNeeded = Math.ceil(final / 50);

    setResults({
      usedArea1: usedArea1.toFixed(2),
      usedArea2: usedArea2.toFixed(2),
      remainingArea: remainingArea.toFixed(2),
      totalBlocks: final.toFixed(2),
      cementBags: cementNeeded,
    });
    setShowResult(true);
  };

  return (
    <div> 
      <Header/>
    <div className="blockwork-container">

      {/* Block Type Toggle */}
      <fieldset>
        <legend>Blockwork Estimation</legend>
        <div className="toggle-container">
          <input
            type="radio"
            id="blockCentreLine"
            name="blockType"
            value="centreLine"
            checked={selectedOption === 'centreLine'}
            onChange={handleRadioChange}
          />
          <label htmlFor="blockCentreLine">Blockwork Using Centre Line Girth</label>

          <input
            type="radio"
            id="blockSquareMetre"
            name="blockType"
            value="squareMetre"
            checked={selectedOption === 'squareMetre'}
            onChange={handleRadioChange}
          />
          <label htmlFor="blockSquareMetre">Blockwork Using Square Metre</label>
        </div>
      </fieldset>

      {/* Centre Line Girth Form */}
      {selectedOption === 'centreLine' && (
        <div className="form-content">
          <fieldset>
            <legend>Blockwork Using Centre Line Girth</legend>

            <label htmlFor="totalGirth">Total Centre Line Girth (m):</label>
            <input
              type="number"
              onChange={(e) => setTotalGirth(e.target.value)}
              placeholder="Enter total girth"
            />

            <label htmlFor="blockHeight">Height of the Block (m):</label>
            <input
              type="number"
              onChange={(e) => setBlockHeight(e.target.value)}
              placeholder="Enter Building Height"
            />
            <p>If there are no DDT openings, leave the inputs below blank.</p>

            <label>DDT for Windows/Openings:</label>
            {input1Groups.map((group, index) => (
              <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                <input type="number" placeholder="Length" value={group.ddt1Length} onChange={(e) => handleInput1Change(index, "ddt1Length", e.target.value)} />
                <input type="number" placeholder="Height" value={group.ddt1Height} onChange={(e) => handleInput1Change(index, "ddt1Height", e.target.value)} />
                <input type="number" placeholder="Quantity" value={group.ddt1Quantity} onChange={(e) => handleInput1Change(index, "ddt1Quantity", e.target.value)} />
                <button style={{ display: "flex", gap: "10px", marginBottom: "10px" }} onClick={handleAdd1Group}>Add</button>
                {input1Groups.length > 1 && <button style={{ display: "flex", gap: "10px", marginBottom: "10px" }} onClick={() => handleDelete1Group(index)}>Delete</button>}
              </div>
            ))}

            <label>DDT for Doors/Openings:</label>
            {input2Groups.map((group, index) => (
              <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                <input type="number" placeholder="Length" value={group.ddt2Length} onChange={(e) => handleInput2Change(index, "ddt2Length", e.target.value)} />
                <input type="number" placeholder="Height" value={group.ddt2Height} onChange={(e) => handleInput2Change(index, "ddt2Height", e.target.value)} />
                <input type="number" placeholder="Quantity" value={group.ddt2Quantity} onChange={(e) => handleInput2Change(index, "ddt2Quantity", e.target.value)} />
                <button style={{ display: "flex", gap: "10px", marginBottom: "10px" }} onClick={handleAdd2Group}>Add</button>
                {input2Groups.length > 1 && <button style={{ display: "flex", gap: "10px", marginBottom: "10px" }} onClick={() => handleDelete2Group(index)}>Delete</button>}
              </div>
            ))}

            <button type="button" onClick={ClineGirtHandle}>Submit</button>
          </fieldset>
        </div>
      )}

      {/* Square Metre Form */}
      {selectedOption === 'squareMetre' && (
        <div className="form-content">
          <fieldset>
            <legend>Blockwork Using Square Metre</legend>

            <label htmlFor="blockLength">Length (m):</label>
            <input type="number" onChange={(e) => setTotalGirth(e.target.value)} placeholder="Enter length" />

            <label htmlFor="blockBreadth">Breadth (m):</label>
            <input type="number" onChange={(e) => setBreadth(e.target.value)} placeholder="Enter breadth" />

            <label htmlFor="blockHeightSquare">Height (m):</label>
            <input type="number" onChange={(e) => setBlockHeight(e.target.value)} placeholder="Enter height" />

            <label>DDT for Windows:</label>
            {input1Groups.map((group, index) => (
              <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                <input type="text" placeholder="DDT Length" value={group.ddt1Length} onChange={(e) => handleInput1Change(index, "ddt1Length", e.target.value)} />
                <input type="text" placeholder="DDT Height" value={group.ddt1Height} onChange={(e) => handleInput1Change(index, "ddt1Height", e.target.value)} />
                <input type="text" placeholder="Quantity" value={group.ddt1Quantity} onChange={(e) => handleInput1Change(index, "ddt1Quantity", e.target.value)} />
                <button style={{ display: "flex", gap: "10px", marginBottom: "10px" }} onClick={handleAdd1Group}>Add</button>
                {input1Groups.length > 1 && <button style={{ display: "flex", gap: "10px", marginBottom: "10px" }} onClick={() => handleDelete1Group(index)}>Delete</button>}
              </div>
            ))}

            <label>DDT for Doors:</label>
            {input2Groups.map((group, index) => (
              <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                <input type="text" placeholder="DDT Length" value={group.ddt2Length} onChange={(e) => handleInput2Change(index, "ddt2Length", e.target.value)} />
                <input type="text" placeholder="DDT Height" value={group.ddt2Height} onChange={(e) => handleInput2Change(index, "ddt2Height", e.target.value)} />
                <input type="text" placeholder="Quantity" value={group.ddt2Quantity} onChange={(e) => handleInput2Change(index, "ddt2Quantity", e.target.value)} />
                <button style={{ display: "flex", gap: "10px", marginBottom: "10px" }}  onClick={handleAdd2Group}>Add</button>
                {input2Groups.length > 1 && <button style={{ display: "flex", gap: "10px", marginBottom: "10px" }} onClick={() => handleDelete2Group(index)}>Delete</button>}
              </div>
            ))}

            <button type="button" onClick={SquareMetreHandle}>Submit</button>
          </fieldset>
        </div>
      )}

      {/* Result Popup */}
      {showResult && (
        <div className="result-wrapper" onClick={() => setShowResult(false)}>
          <div className="result-display" onClick={(e) => e.stopPropagation()}>
            <div className="close-result" onClick={() => setShowResult(false)}>X</div>
            <div className="result-container">
              <p>Total Blocks Needed: <strong>{results.totalBlocks}</strong> blocks</p>
              <p>Total Bags of Cement Needed: <strong>{results.cementBags}</strong> bags</p>
              <p>10% contigency has been included</p>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default Blockwork;
